import { useContext } from 'react'
import { observer } from 'mobx-react'
import { EditTreeContext, EditPage } from 'src/components'

const EditTreePageMain = () => {
  const tree = useContext(EditTreeContext)

  if (!tree.selectedKeys.length) return null

  const code = tree.treeConfig.Nav_Form?.CODE
  return (
    <div className='tree-page__main'>
      {code ? <EditPage formCode={tree.treeConfig.Nav_Form.CODE} formData={{ formId: tree.selectedKeys[0] }} /> : null}
    </div>
  )
}

export default observer(EditTreePageMain)